import type { ItineraryItem } from '@elara/client-core/models/ItineraryItemModel';

import { DetailRow } from './ItineraryDetailRow.js';

/**
 * A booked item's references, for the printed itinerary only — the details a traveler quotes at a
 * hotel desk or airline counter. On screen they sit behind "View booking"; on paper there is no
 * dialog to open. Renders nothing for an item without booking details.
 */
export function PrintBookingDetails({
  item,
  includeConfirmation = true,
}: {
  item: ItineraryItem;
  /** False where the block already shows the confirmation number (the flight leg's rows). */
  includeConfirmation?: boolean;
}) {
  const booking = item.booking;
  if (!booking) return null;

  const lead = booking.leadGuest;
  const guestName = lead ? [lead.title, lead.firstName, lead.lastName].filter(Boolean).join(' ') : undefined;
  const confirmationNumber = includeConfirmation ? booking.confirmationNumber : undefined;
  if (!confirmationNumber && !booking.reference && !booking.provider && !guestName) return null;

  return (
    <div className="hidden print:flex flex-col text-sm">
      {confirmationNumber && (
        <DetailRow icon="confirmation_number" secondary="Confirmation number" value={confirmationNumber} />
      )}
      {booking.reference && <DetailRow icon="tag" secondary="Booking reference" value={booking.reference} />}
      {booking.provider && <DetailRow icon="storefront" secondary="Booked with" value={booking.provider} />}
      {guestName && <DetailRow icon="person" secondary="Lead guest" value={guestName} />}
    </div>
  );
}
